module.exports = __webpack_public_path__ + "static/media/HomeRoll_Walls_WbOtherTimberWall.80cd6529.jpg";